import React, { useState, useEffect } from "react";
import { Checkbox } from "antd";
import EnhanceTip from "./common/enhanceTip";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

const CheckboxGroup = Checkbox.Group;

export default ({
  data,
  getText,
  setRetrieveValues,
  btnRequestHandle,
  setSubmitState,
  isStreaming,
}: {
  data: IMultiElementCombineMsg.ICheckBoxElem;
  getText: (text: IMultiElementCombineMsg.IText | string | undefined) => string;
  setRetrieveValues: (value: IMultiElementCombineMsg.IRetrieveValues) => void;
  btnRequestHandle: ({
    url,
    btnId,
    elem,
    extra,
  }: IMultiElementCombineMsg.ISubmitParams) => void;
  setSubmitState: (tipCheck: IMultiElementCombineMsg.ITipCheck) => void;
  isStreaming: boolean;
}) => {
  const {
    content = [],
    is_multiple,
    id,
    type,
    action_url,
    required,
    required_tips,
    prompt_tips,
    extra,
  } = data;

  const style = getDefaultComponentStyle(data);

  const [checkedList, setCheckedList] = useState(() => {
    const defaultOption =
      content && content.length
        ? content.filter((item) => item.checked).map((item) => item.value)
        : [];
    return defaultOption;
  });

  useEffect(() => {
    const list =
      content && content.length
        ? content.filter((item) => item.checked).map((item) => item.value)
        : [];
    setCheckedList(list);
  }, [content]);

  useEffect(() => {
    try {
      const value = Array.isArray(checkedList) ? checkedList.join() : "";
      setRetrieveValues({ id, type, value });
    } catch (error) {
      console.log("checkedList", error);
    }
  }, [checkedList]);

  const onChange = (list: any[]) => {
    let curList = [...list];

    // 处理单选,单选支持反选
    if (!is_multiple) {
      if (list.length > checkedList.length) {
        curList = list.filter((item) => !checkedList.includes(item));
      } else if (list.length > 0) {
        // curList = checkedList.filter((item: string[]) => !list.includes(item));
      }
    }

    setCheckedList(curList);
    const value = curList.join();

    // if (required && !value) return;
    action_url &&
      btnRequestHandle({ url: action_url, elem: { id, type, value }, extra });
  };

  return (
    <div style={style}>
      <EnhanceTip
        id={id}
        isEmpty={!checkedList || !checkedList.length}
        required={required}
        required_tips={required_tips}
        prompt_tips={prompt_tips}
        setSubmitState={setSubmitState}
      >
        <div onClick={(e) => e.stopPropagation()}>
          <CheckboxGroup
            options={content.map((item) => ({
              label: getText(item.title),
              value: item.value,
              disabled: isStreaming ? true : !item.can_operate,
            }))}
            value={checkedList}
            onChange={onChange}
          />
        </div>
      </EnhanceTip>
    </div>
  );
};
